import { yupResolver } from "@hookform/resolvers/yup";
import {
  Badge,
  Button,
  Card,
  Divider,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputLabel,
  OutlinedInput,
  Stack,
  Typography,
  Select,
  Chip,
  MenuItem
} from "@mui/material";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import React, { useState, useRef, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import Appbar from "../../../components/Appbar";
import Body from "../../../components/Body";
import Drawer from "../../../components/Drawer";
import { addEventModuleSettingsApi } from "../../../store/event-module/settings/addevent";
import { EditEventModuleSettingApi } from "../../../store/event-module/settings/editevent";
import { uploadImageApi } from "../../../store/upload/uploadImage";
import ImageUploading from "react-images-uploading";
import { toast } from "react-hot-toast";
import BackdropUI from "../../../ui/Backdrop";
import { uploadHandoutsApi } from "../../../store/upload/uploadHandouts";
const schema = yup
  .object({
    animation_type: yup.string().required("Please select animation type").trim()
      .matches(/^[^!@#$%^&*+=<>:;|~]*$/, {
        message: 'No symbols should be there in animation type'
      })
    ,
  })
  .required();

export default function EventModuleEdit() {
  const settingDetails = useSelector((state) => state?.settingDetails);
  const [fileUploadLoader, setFileUploadLoader] = useState(false);
  const [fileUploadLoader2, setFileUploadLoader2] = useState(false);
  const uploadImage = useSelector((state) => state?.uploadImage);
  const [animation_type, setAnimation] = useState();

  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });
  const params = useParams();
  const navigate = useNavigate();
  const classAdd = useSelector((state) => state?.addEventModule);
  const classEdit = useSelector((state) => state?.EditEventModule);
  const historyLocation = useLocation();
  const [imageLink2, setImageLink2] = useState(null);
  const [images2, setImages2] = React.useState([]);
  const [handOuts, setHandouts] = React.useState([]);
  const refInput = useRef(null);
  const animatiList = [
    { "title": "rail" },
    { "title": "rocket" }]
  const { eventModuleData } = historyLocation.state || {};
  const handleUpdateForm = async (value) => {
    var newObj;
    newObj = { ...value, ...params };
    if (imageLink2) {
      newObj = { ...newObj, background_image_url: imageLink2 };
    } else if (images2.length > 0 && !uploadImage?.loading && uploadImage.result) {
      newObj = { ...newObj, background_image_url: uploadImage.result };
    } else {
      toast.error("Please Upload An Image", {
        id: "toast",
        duration: 1000,
        position: "top-center",
      });
      return;
    }
    if (handOuts.length === 0) {

      toast.error("Please Upload An File", {
        id: "toast",
        duration: 1000,
        position: "top-center",
      });
      return;
    }
    newObj = {
      ...newObj, event_guidelines_url: handOuts[0].fileUrl,
    };
    if (params.setting_id) {
      await dispatch(EditEventModuleSettingApi(newObj));
      if (!classEdit?.loading) {
        navigate("/events");
      }
    } else {
      await dispatch(addEventModuleSettingsApi(newObj));
      if (!classAdd?.loading) {
        navigate("/events");
      }
    }
  };
  const onUploadHandout = async (file) => {
    setFileUploadLoader(true)
    let formData = new FormData();
    formData.append("file", file);
    dispatch(uploadHandoutsApi(formData)).then((res) => {
      if (res.payload.result.length > 0 && !res.payload.result.error) {
        let obj = {
          fileName: file.name,
          fileUrl: res.payload.result,
        };
        setHandouts([...handOuts, obj]);
        refInput.current.value = null;
        setFileUploadLoader(false)
      }
    })
  };
  const handleHandoutDelete = (element) => {
    var local = handOuts;
    setHandouts(local.filter((item) => item !== element));
  };
  const onUploadImage2 = async (imageList, addUpdateIndex) => {
    try {
      let formData = new FormData();
      formData.append("file", imageList[0]?.file);
      if (imageList.length > 0) {
        setFileUploadLoader2(true);
        dispatch(uploadImageApi(formData)).then((action) => {
          if (!action.type.includes("rejected")) {
            setImages2(imageList);
            setImageLink2(action.payload.result);
          }
          if (action.type.includes("rejected")) {
            setImages2([]);
          }
        }).finally(() => {
          setFileUploadLoader2(false);
        })
      }
    } catch (e) {
      console.log(e)
    } finally {
      setImages2(imageList);
      // setFileUploadLoader(false)
    }

  };
  useEffect(() => {
    let defalutValues = {};
    if (params.setting_id) {
      setImageLink2(eventModuleData?.background_image);
      setAnimation(eventModuleData?.animation_type);
      if (eventModuleData?.event_guidelines) {
        let document = { fileUrl: eventModuleData?.event_guidelines, fileName: eventModuleData?.event_guidelines }
        setHandouts([document]);
      }
    }
    reset(defalutValues);
  }, [eventModuleData]);

  return (
    <>
      <Appbar />
      <Drawer />
      <Body>
        <form onSubmit={handleSubmit(handleUpdateForm)}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Card>
                <Typography>Event Setting Module Details</Typography>
                <Stack spacing={2} my={2}>
                  <Divider />

                  <InputLabel>Event Guidlines</InputLabel>
                  <Stack
                    direction="row"
                    spacing={1}
                    style={{ display: " inline" }}
                  >
                    {handOuts.map((i, element) => (
                      <>
                        <Chip
                          key={element}
                          label={i.fileName}
                          variant="outlined"
                          className=""
                          style={{ marginTop: "5px" }}
                          onDelete={() => handleHandoutDelete(i)}
                        />
                      </>
                    ))}
                  </Stack>
                  <input
                    accept="application/pdf"
                    style={{ display: "none" }}
                    id="raised-button-file"
                    type="file"
                    ref={refInput}
                    onChange={(e) => onUploadHandout(e.target?.files[0])}
                  />
                  <Stack
                    direction="row"
                    spacing={1}
                    style={{ display: " block", marginTop: "2%" }}
                  >
                    {handOuts.length > 0 ? null : <Button
                      variant="contained"
                      color="primary"
                      onClick={() => refInput.current.click()}
                    >
                      Upload File
                    </Button>}
                  </Stack>
                  <InputLabel>Background Image</InputLabel>
                  {imageLink2 ? (
                    <div className="image-item">
                      <img src={`${imageLink2}?t=${Date.now()}`} alt="" width="320" height="180" />
                      <div className="image-item__btn-wrapper">
                        <Button
                          onClick={() => setImageLink2(null)}
                          variant="contained"
                        >
                          Remove
                        </Button>
                      </div>
                    </div>
                  ) : (
                    <ImageUploading
                      acceptType={['png', 'jpeg', 'jpg']}
                      value={images2}
                      onChange={onUploadImage2}
                      maxNumber={1}
                      dataURLKey="data_url"
                    >
                      {({
                        imageList,
                        onImageUpload,
                        onImageUpdate,
                        onImageRemove,
                        isDragging,
                        dragProps,
                        errors,
                      }) => (
                        <>
                          <div
                            className="upload__image-wrapper"
                            style={{ marginTop: "2%", marginBottom: "2%" }}
                          >
                            {imageList.length > 0 ? null : (
                              <Button
                                type="button"
                                variant="contained"
                                style={isDragging ? { color: "red" } : undefined}
                                onClick={onImageUpload}
                                {...dragProps}
                              >
                                Click or Drop here
                              </Button>
                            )}
                            {errors && (
                              <div>
                                {errors.maxNumber && (
                                  <span>
                                    Number of selected images exceed maxNumber
                                  </span>
                                )}
                                {errors.acceptType && (
                                  <span>
                                    Your selected file type is not allow
                                  </span>
                                )}
                                {errors.maxFileSize && (
                                  <span>
                                    Selected file size exceed maxFileSize
                                  </span>
                                )}
                                {errors.resolution && (
                                  <span>
                                    Selected file is not match your desired
                                    resolution i.e (328*150)
                                  </span>
                                )}
                              </div>
                            )}
                            {imageList.map((image, index) => (
                              <div key={index} className="image-item">
                                <img
                                  src={image["data_url"]}
                                  alt=""
                                  width="320" height="180"
                                />
                                <div className="image-item__btn-wrapper">
                                  <Button
                                    onClick={() => onImageUpdate(index)}
                                    variant="contained"
                                    sx={{ mr: 2 }}
                                  >
                                    Update
                                  </Button>
                                  <Button
                                    onClick={() => onImageRemove(index)}
                                    variant="contained"
                                  >
                                    Remove
                                  </Button>
                                </div>
                              </div>
                            ))}
                          </div>
                        </>
                      )}
                    </ImageUploading>
                  )}
                </Stack>
                <Stack direction="row" spacing={2}>
                  <FormControl variant="outlined" fullWidth>
                    <InputLabel shrink>Animation Type*</InputLabel>
                    <Select
                      {...register("animation_type")}
                      label="Animation Type"
                      id="outlined-adornment-animation_type"
                      value={animation_type ? animation_type : null}
                      notched
                      error={errors?.animation_type?.message}
                      onChange={(e) => setAnimation(e.target.value)}
                    >
                      {animatiList?.map((value, index) => (
                        <MenuItem value={value.title} key={index}>
                          {value.title}
                        </MenuItem>
                      ))}
                    </Select>

                    <FormHelperText error>
                      {errors?.animation_type?.message}
                    </FormHelperText>
                  </FormControl>
                </Stack>
              </Card>
              <Button
                type="button"
                sx={{ float: "right", mt: 2, ml: 2 }}
                variant="contained"
                onClick={() => navigate(-1)}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                sx={{ float: "right", mt: 2 }}
                variant="contained"
              >
                {params.setting_id ? "Update" : "Create"}
              </Button>
            </Grid>
          </Grid>
        </form>
      </Body>
      <BackdropUI open={fileUploadLoader || fileUploadLoader2} />
    </>
  );
}
